import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import customerServices from '../customerServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';


function CustomerForm({data,callBack,callBackWithId }) {

    const {AppAlert} = useAlert();
    const {masters} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {
        customerName:"",
        customerOrg:"",
        gst:"",
        phone:"",
        email:"",
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            customerName:data.customerName,
            customerOrg:data.customerOrg,
            gst:data.gst,
            phone:data.phone,
            email:data.email,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        customerName:Yup.string().required("Required"),
        phone:Yup.string().matches(/^[0-9]+$/, "Phone number must contain only digits").length(10, "Phone number must be exactly 10 digits").required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        let customerDetails = {...values};
        if(customerDetails.gst === ""){
            delete customerDetails.gst;
        }
        customerServices.save(customerDetails).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            if(callBackWithId){
                callBackWithId(res.id);
            } else {
                callBack();
            }
            
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New Customer</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Add New"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Customer Name" name="customerName" 
                                                        
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Customer org" name="customerOrg" 
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="GST" name="gst" 
                                                    />
                                                </div>

                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Phone" name="phone" 
                                                    />
                                                </div>
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Email" name="email"   
                                                    />
                                                </div>

                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { /* JSON.stringify(formik.values)  */}
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default CustomerForm